<div class="textCenter">
  <ion-row>
    <ion-col size="6" *ngFor="let rel of mother">
      <app-node [rel]="rel" (clickRel)="clickRel($event)"></app-node>
    </ion-col>
    <ion-col size="6" *ngFor="let rel of father">
      <app-node [rel]="rel" (clickRel)="clickRel($event)"></app-node>
    </ion-col>
  </ion-row>
  <br>
  <ion-row>
    <ion-col size="3" style="position: relative;">
      <div style="position: absolute; top: 35%; right:20%" *ngFor="let rel of wife">
        <app-node [rel]="rel" (clickRel)="clickRel($event)"></app-node>
      </div>
      <div style="position: absolute; top: 35%; right:20%" *ngFor="let rel of husband">
        <app-node [rel]="rel" (clickRel)="clickRel($event)"></app-node>
      </div>
    </ion-col>
    <ion-col size="6" style="position: relative;">
      <div style="position: absolute; top: 30%; left: 30%;" (click)="clickCenter.emit()">
        <div class="node setBg" *ngIf="emp && emp.user && emp.user.url"
          [ngStyle]="{'background-image': 'url(' +emp.user.url+ ')'}">
          Self
        </div>
        <div class="node" *ngIf="!emp || !emp.user || !emp.user.url">
          Self
        </div>
        <span *ngIf="emp && emp.user">{{emp.user.name}}</span>
        <span *ngIf="!emp || !emp.user">Self</span>
      </div>
    </ion-col>
    <ion-col size="3">
      <ion-row>
        <ion-col size="12" *ngFor="let rel of brother">
          <app-node [rel]="rel" (clickRel)="clickRel($event)"></app-node>
        </ion-col>
        <ion-col size="12" *ngFor="let rel of sister" (click)="clickRel(rel)">
          <app-node [rel]="rel" (clickRel)="clickRel($event)"></app-node>
        </ion-col>
      </ion-row>

    </ion-col>
  </ion-row>
  <br>
  <br>
  <br>
  <ion-row>
    <ion-col *ngFor="let rel of daughter">
      <app-node [rel]="rel" (clickRel)="clickRel($event)"></app-node>
    </ion-col>
    <ion-col *ngFor="let rel of son">
      <app-node [rel]="rel" (clickRel)="clickRel($event)"></app-node>
    </ion-col>
  </ion-row>
</div>